// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_EncerramentosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /rede/encerramentos — todos os encerramentos, os a conferir primeiro (Full). */
import type { Rede_EncerramentoRow } from './Rede_EncerramentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Rede_EncerramentosResponseDados {
encerramentos: Rede_EncerramentoRow[]
total: number
a_conferir: number
para_casar: number
}

export type Rede_EncerramentosResponse = ApiResponse<Rede_EncerramentosResponseDados>;

registerResponseContract('Rede_EncerramentosResponse', {
  encerramentos: {
    type: 'array',
    required: true,
    items: {
      id:            { type: 'number',  required: true },
      unidade:       { type: 'string',  required: false },
      nome:          { type: 'string',  required: false },
      origem:        { type: 'string',  required: true },
      situacao:      { type: 'string',  required: true },
      a_conferir:    { type: 'boolean', required: false },
      divergencia:   { type: 'string',  required: false },
      pendentes:     { type: 'number',  required: false },
      destino:       { type: 'string',  required: false },
      concluido_em:  { type: 'string',  required: false },
      atualizado_em: { type: 'string',  required: true },
    },
  },
  total:         { type: 'number',  required: true },
  a_conferir:    { type: 'number',  required: true },
  para_casar:    { type: 'number',  required: true },
})
